// extracted by mini-css-extract-plugin
var _1 = "RequestExportInvoiceModal-modulebtn__zslrC";
var _2 = "RequestExportInvoiceModal-modulemessage__ayzgr";
export { _1 as "btn", _2 as "message" }
